export default __webpack_public_path__ + "static/media/estudiante.1ea4fbda.jpg";